module.exports = __webpack_public_path__ + "img/victory-points-icon.848b7d0e.svg";